import { lazy } from "./lazy.js";
import { scroll } from "./scroll.js";
import { ListAccordion } from "../../../views/sections/main";

export const initPage = () => {
  if (lazy) {
    lazy.update();
  }
  if (scroll) {
    scroll.update();
  }

  new ListAccordion();

  //initText()
};
